import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import {
  BOTTOM_STICKY_PORTAL_ID,
  PAGE_CONTENT_CONTAINER_ID,
  SCROLL_CONTAINER_ID,
} from '@/components/app-layout/app-layout.constants';
import {
  bottomStickyPortalAtom,
  pageContentAtom,
  scrollContainerAtom,
} from '@/components/app-layout/app-layout.state';

/**
 * Initializes the layout by setting the scroll container and page content container.
 * This is used to ensure that the scroll container and page content container are available
 * throughout the application.
 *
 * @returns void
 */
export const useInitLayout = () => {
  const setScrollContainer = useSetAtom(scrollContainerAtom);
  const setPageContent = useSetAtom(pageContentAtom);
  const setBottomStickyPortal = useSetAtom(bottomStickyPortalAtom);

  useEffect(() => {
    setScrollContainer(document.getElementById(SCROLL_CONTAINER_ID) as HTMLDivElement);
    setPageContent(document.getElementById(PAGE_CONTENT_CONTAINER_ID) as HTMLDivElement);
    setBottomStickyPortal(document.getElementById(BOTTOM_STICKY_PORTAL_ID) as HTMLDivElement);
  }, []);
};
